export function routes($stateProvider) {
    $stateProvider
        .state('app.funciona.oi', {
        url: '/ordens-intervencao',
        abstract: true
    })
        .state('app.funciona.oi.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Ordens de Intervenção',
        template: require('./list/view.html'),
        role: ['funcionaVerOIs'],
        controller: 'FunOIListController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.funciona.oi.details', {
        url: '/{id:int}',
        title: 'Detalhes da Ordem de Intervenção',
        template: require('./details/view.html'),
        role: ['funcionaVerOIs'],
        controller: 'FunOIDetailsController',
        controllerAs: 'vm',
    });
}
routes.$inject = ['$stateProvider'];
